import {combineReducers} from 'redux';
import main from './main';
import domain from './domain';

const reducer = combineReducers({
    main,
    domain
})


export default reducer ;
